import { jsx as _jsx } from "react/jsx-runtime";
const TideeLogo = ({ align = 'left', bold = false, children, className = '', reverse = false, size, }) => {
    const style = {
        color: reverse ? '#ffffff' : 'var(--color-primary-800)',
        fontFamily: bold
            ? "'poppinssemibold', helvetica, arial"
            : "'poppinsmedium', helvetica, arial",
        fontSize: `${size}px`,
        lineHeight: `${size}px`,
        textAlign: align,
        textDecoration: 'none',
    };
    return (_jsx("div", { 
        /*
         * The brand name is a name, not a word, and must survive a
         * machine translation of the page.
         *
         * Chrome's auto-translate read "tidee" on the French site
         * as the French "idée" and rendered the logo as "idee" —
         * the t silently eaten. It looks for all the world like a
         * CSS bug, the wordmark sliding behind the cube, which is
         * what it was first reported as.
         *
         * translate="no" is the HTML attribute for this and is
         * what Chrome honours; .notranslate is the older Google
         * Translate widget's equivalent, which costs nothing to
         * carry and covers the embedded-widget case.
         */
        className: `notranslate ${className}`.trim(), translate: "no", style: style, children: children }));
};
export default TideeLogo;
//# sourceMappingURL=tidee-logo.js.map